import styled from "@emotion/styled";
import { Card, Theme } from "@mui/material";
import isPropValid from '@emotion/is-prop-valid';

export const StyledCard = styled(Card,{ shouldForwardProp: prop => prop !== "isBetter" && isPropValid(prop)})<{ theme: Theme, isBetter?: boolean }>((props) => ({
  border: `${ props.isBetter ? props.theme.palette.secondary.main : 'rgba(0,0,0,0.5)'} solid 2px`,
  padding: props.theme.spacing(2),
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  alignItems: "center",
  borderRadius: "10px",
  marginBottom: props.theme.spacing(1.5)
}));
